module.exports = __webpack_public_path__ + "static/media/learn-coding-video.19791a2d.webp";